import React, { useState } from "react";
import { colors, font } from "../utils/theme.js";

// Compact multi-select filter control: a button that opens a checklist popover.
// options: string[]; selected: string[]; onChange: (string[]) => void
export default function MultiSelect({ label, options, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const sel = new Set(selected);
  const toggle = (v) => {
    const next = new Set(sel);
    next.has(v) ? next.delete(v) : next.add(v);
    onChange([...next]);
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          padding: "8px 12px", background: sel.size ? colors.accentDim : colors.bg,
          border: `1px solid ${sel.size ? colors.accent : colors.borderLight}`, borderRadius: 8,
          color: sel.size ? colors.accent : colors.textMuted, fontSize: 13, fontFamily: font, cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        {label}{sel.size ? ` (${sel.size})` : ""} ▾
      </button>
      {open && (
        <>
          {/* click-away overlay */}
          <div style={{ position: "fixed", inset: 0, zIndex: 40 }} onClick={() => setOpen(false)} />
          <div style={{
            position: "absolute", top: "calc(100% + 6px)", left: 0, zIndex: 41, minWidth: 220, maxWidth: 300,
            maxHeight: 320, overflowY: "auto", background: colors.surface, border: `1px solid ${colors.border}`,
            borderRadius: 10, padding: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 8px 8px" }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: colors.textDim, textTransform: "uppercase", letterSpacing: 1 }}>{label}</span>
              {sel.size > 0 && <button onClick={() => onChange([])} style={{ background: "none", border: "none", color: colors.accent, fontSize: 11, cursor: "pointer", fontFamily: font }}>Clear</button>}
            </div>
            {options.length === 0 ? (
              <div style={{ fontSize: 12, color: colors.textDim, padding: "6px 8px" }}>No values</div>
            ) : options.map((opt) => (
              <label key={opt} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 8px", borderRadius: 6, cursor: "pointer", fontSize: 13, color: colors.text }}>
                <input type="checkbox" checked={sel.has(opt)} onChange={() => toggle(opt)} style={{ accentColor: colors.accent }} />
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{opt}</span>
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
